import React from 'react';
import { useNavigate } from 'react-router-dom';
import whatsComingIcon from 'src/styles/landing-page/quick-actions-what-is-coming.svg';
import requestProjectIcon from 'src/styles/landing-page/quick-actions-request-project.svg';
import howWeWorkIcon from 'src/styles/landing-page/quick-actions-how-we-work.svg';
import trainingIcon from 'src/styles/landing-page/quick-actions-training-tutorials.svg';
import aiForFinanceIcon from 'src/styles/landing-page/quick-actions-ai-for-finance.svg';
import mcpServersIcon from 'src/styles/landing-page/quick-actions-mcp-servers.svg';
import ActionCard from './ActionCard';
import { SECTION_TITLES } from './landing-page-constants';

interface QuickAction {
  id: string;
  title: string;
  description: string;
  icon?: string;
  href?: string;
  internalRoute?: string;
}

const QUICK_ACTIONS: QuickAction[] = [
  {
    id: 'request-project',
    title: 'Request a Project',
    description: 'Submit and track new project requests.',
    icon: requestProjectIcon,
    href: 'https://form.asana.com/?k=CeScTOvZSeFYjFMV7ivu_g&d=8442528107068'
  },
  {
    id: 'whats-coming',
    title: "What's Coming",
    description: 'See what the DaS FinTech team is building next.',
    icon: whatsComingIcon,
    href: 'https://app.asana.com/0/portfolio/1203595588028142/list'
  },
  {
    id: 'how-we-work',
    title: 'How We Work',
    description: 'Understand the intake process and project lifecycle.',
    icon: howWeWorkIcon,
    href: 'https://w.amazon.com/bin/view/DaS-FinTech/Project_Management_SOP'
  },
  {
    id: 'mcp-servers',
    title: 'MCP Servers',
    description: 'Connect AI assistants to internal data tools.',
    icon: mcpServersIcon,
    internalRoute: '/mcp'
  },
  {
    id: 'ai-for-finance',
    title: 'AI for Finance',
    description: 'AI-powered tools for finance teams.',
    icon: aiForFinanceIcon,
    href: 'https://amazon.sharepoint.com/sites/DaSaiToolsHub'
  },
  {
    id: 'training-tutorials',
    title: 'Training & Tutorials',
    description: 'Guides, tutorials, and onboarding.',
    icon: trainingIcon,
    href: 'https://broadcast.amazon.com/channels/30022'
  }
];

/**
 * @feature landing-page
 * @owner das-finsuite-application-dev
 * @description Quick Actions section — horizontal row of action cards with icons.
 */
const QuickActionsSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-section">
      <div className="landing-section__header">
        <h4>{SECTION_TITLES.quickActions}</h4>
      </div>
      <div className="landing-section__cards-row">
        {QUICK_ACTIONS.map((item) => (
          <ActionCard
            key={item.id}
            title={item.title}
            description={item.description}
            href={item.href}
            onClick={item.internalRoute ? () => navigate(item.internalRoute as string) : undefined}
            icon={item.icon ? <img src={item.icon} alt={item.title} width={54} height={54} /> : undefined}
          />
        ))}
      </div>
    </div>
  );
};

export default QuickActionsSection;
